"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var sis_textbox_settings_component_1 = require("./sis-textbox-settings.component");
var sis_control_with_settings_1 = require("../../sis-control-with-settings");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var SisTextBoxComponent = /** @class */ (function (_super) {
    __extends(SisTextBoxComponent, _super);
    function SisTextBoxComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dir = 'ltr';
        _this.isReadonly = false;
        _this.valueChange = new core_1.EventEmitter();
        return _this;
    }
    Object.defineProperty(SisTextBoxComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
            this.valueChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTextBoxComponent.prototype, "maxlength", {
        get: function () {
            return this._maxlength;
        },
        set: function (val) {
            if (val) {
                this._maxlength = val;
            }
            else {
                this._maxlength = 200;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTextBoxComponent.prototype, "characterCountSettings", {
        set: function (value) {
            this._showCharactersCount = idm_ng_controls_1.CharacterCountSettings.fromJsonString(value).showCharacterCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTextBoxComponent.prototype, "showCharactersCount", {
        get: function () {
            return this._showCharactersCount;
        },
        enumerable: true,
        configurable: true
    });
    SisTextBoxComponent.prototype.ngOnInit = function () {
        if (this.type !== 'number') {
            this.type = 'text';
        }
    };
    SisTextBoxComponent.prototype.getIsReadonly = function () {
        return this.isReadonly;
    };
    SisTextBoxComponent.prototype.onKeyPress = function (evt) {
        if (this.value &&
            this.maxlength &&
            this.value.toString().length > this.maxlength) {
            evt.preventDefault();
        }
    };
    SisTextBoxComponent.prototype.onBlur = function () {
        this._value = this._value && this._value.trim();
        this.valueChange.emit(this.value);
    };
    SisTextBoxComponent._numberRegExp = new RegExp('^[+,-]?[0-9]+[.]?[0-9]*$');
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTextBoxComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTextBoxComponent.prototype, "placeholder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTextBoxComponent.prototype, "dir", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTextBoxComponent.prototype, "type", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTextBoxComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisTextBoxComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisTextBoxComponent.prototype, "value", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], SisTextBoxComponent.prototype, "maxlength", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisTextBoxComponent.prototype, "characterCountSettings", null);
    SisTextBoxComponent = __decorate([
        core_1.Component({
            selector: 'sis-textbox',
            template: require('./sis-textbox.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Text box',
            settings: {
                main: sis_textbox_settings_component_1.SisTextBoxSettingsComponent,
            },
            cellCount: 6,
            template: "\n                        <sis-textbox [id]=\"'%{id}'\" [(value)]=\"%{field}\" [placeholder]=\"%{placeholder}\"\n                                     [maxlength]=\"%{maxLength}\" [type]=\"%{type}\" [hint]=\"%{hint}\"\n                                     [dir]=\"%{dir}\" [characterCountSettings]=\"%{characterCountSettings}\"\n                                     [isReadonly]=\"%{isReadonly}\">\n                        </sis-textbox>\n                     ",
            isFieldBound: true,
        })
    ], SisTextBoxComponent);
    return SisTextBoxComponent;
}(sis_control_with_settings_1.SisControlWithSettings));
exports.SisTextBoxComponent = SisTextBoxComponent;
//# sourceMappingURL=sis-textbox.component.js.map